module.exports = __webpack_public_path__ + "static/media/back-icon.c2befcca.svg";